<template>
    <div class="Jsjb_handInput">
        <div class="handInput_left">
            <div class="handInput_title">
                工单信息
            </div>
            <el-form
                label-width="115px"
                :model="wordOrderIputForm"
                :rules="rules"
                label-position="left"
                ref="ruleFormRef"
            >
                <div class="handInput_from">
                    <div class="handInput_from_subTitle">
                        <span class="handInput_from_verticalLine"></span>
                        <p>基础信息</p>
                    </div>
                    <div class="handInput_from_subMain">
                        <!--<div class="handInput_from_subMain_list">-->
                        <!--&lt;!&ndash;<div class="handInput_from_subMain_label">&ndash;&gt;-->
                        <!--&lt;!&ndash;工单编号&ndash;&gt;-->
                        <!--&lt;!&ndash;</div>&ndash;&gt;-->
                        <!--<el-form-item label="工单编号" prop="gdGdbh">-->
                        <!--{{wordOrderIputForm.gdGdbh}}-->
                        <!--&lt;!&ndash;<input class="handInput_from_subMain_input" type="text"&ndash;&gt;-->
                        <!--&lt;!&ndash;v-model="wordOrderIputForm.gdGdbh" placeholder="请输入" @blur="judgeRepeat">&ndash;&gt;-->
                        <!--</el-form-item>-->
                        <!--</div>-->
                        <!--<div class="handInput_from_subMain_list">-->
                            <!--<el-form-item label="上报人" prop="gdSbrmc">-->
                                <!--{{sbPerson}}-->
                                <!--&lt;!&ndash;<input class="handInput_from_subMain_input" type="text"&ndash;&gt;-->
                                <!--&lt;!&ndash;v-model="wordOrderIputForm.gdSbrmc" placeholder="请输入" @blur="judgeRepeat">&ndash;&gt;-->
                            <!--</el-form-item>-->
                        <!--</div>-->
                        <!--<div class="handInput_from_subMain_list">-->
                            <!--<el-form-item label="上报时间" prop="gdSbsj">-->
                                <!--<el-date-picker-->
                                    <!--v-model="wordOrderIputForm.gdSbsj"-->
                                    <!--class="handInput_from_subMain_select"-->
                                    <!--format="YYYY-MM-DD HH:mm:ss"-->
                                    <!--value-format="YYYY-MM-DD HH:mm:ss"-->
                                    <!--type="datetime"-->
                                    <!--placeholder="选择日期时间"-->
                                <!--/>-->
                            <!--</el-form-item>-->
                        <!--</div>-->
                        <!--<div class="handInput_from_subMain_list">-->
                            <!--<el-form-item label="工单类型" prop="gdGdlx">-->
                                <!--<el-select :disabled= "selectReadonly" v-model="wordOrderIputForm.gdGdlx" placeholder="请选择">-->
                                    <!--<el-option v-for="item in selectDataObj.cdg_wgsj_gdlx" :label="item.label"-->
                                               <!--:value="item.value" :disabled="item.disabled"/>-->
                                <!--</el-select>-->
                            <!--</el-form-item>-->
                        <!--</div>-->
                        <div class="handInput_from_subMain_list" style="width: 100%">
                            <el-form-item label="所在网格" prop="gdSzwg">
                                <el-select class="handInput_from_subMain_select" v-model="wordOrderIputForm.gdSzwg"
                                placeholder="请选择">
                                <el-option
                                v-for="item in selectDataObj.cdg_wgsj_afcs"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                />
                                </el-select>
                                <!--<el-cascader-->
                                    <!--class="handInput_from_subMain_select"-->
                                    <!--v-model="wordOrderIputForm.gdAfcs"-->
                                    <!--:options="selectDataObj.cdg_wgsj_afcs"-->
                                    <!--filterable-->
                                    <!--:props="{ emitPath: false }"-->
                                <!--/>-->
                            </el-form-item>
                        </div>
                        <div class="handInput_from_subMain_list" style="width: 100%">
                            <el-form-item label="案发村社" prop="gdAfcs">
                                <el-select class="handInput_from_subMain_select" v-model="wordOrderIputForm.gdAfcs"
                                           placeholder="请选择">
                                    <el-option
                                        v-for="item in afcsSelectArr"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    />
                                </el-select>
                                <!--<el-cascader-->
                                    <!--class="handInput_from_subMain_select"-->
                                    <!--v-model="wordOrderIputForm.gdAfcs"-->
                                    <!--:options="selectDataObj.cdg_wgsj_afcs"-->
                                    <!--filterable-->
                                    <!--:props="{ emitPath: false }"-->
                                <!--/>-->
                            </el-form-item>
                        </div>
                        <div class="handInput_from_subMain_list" style="width: 100%;position: relative;">
                            <el-form-item label="发生地址">
                                <el-input
                                    class="handInput_from_subMain_input inputWordLimit"
                                    v-model="wordOrderIputForm.gdFsdz"
                                    maxlength="100"
                                    placeholder="请输入"
                                    show-word-limit
                                    type="text"
                                />
                                <!--<input class="handInput_from_subMain_input inputWordLimit"-->
                                <!--v-model="wordOrderIputForm.gdFsdz"-->
                                <!--maxlength="100"-->
                                <!--show-word-limit-->
                                <!--type="text"-->
                                <!--placeholder="请输入">-->
                            </el-form-item>
                            <img @click="openMapModal" class="addressBtn" src="../../assets/images/addressButton.png"
                                 alt="">
                        </div>
                        <div class="handInput_from_subMain_list handInput_from_tip" style="width: 100%">
                            <el-form-item label="事件类型" prop="gdSjlx">
                                <el-cascader
                                    class="handInput_from_subMain_select"
                                    v-model="wordOrderIputForm.gdSjlx"
                                    :options="selectDataObj.cdg_wgsjlx"
                                    filterable
                                    @change="sjlxhandleChange"
                                    :props="{ emitPath: false }"
                                />
                                <div v-if="wordOrderIputForm.gdSjlx" class="handInput_from_tipWord">
                                    立案情况：{{sjlxLaqk}}
                                </div>
                                <!--<el-select class="handInput_from_subMain_select" v-model="wordOrderIputForm.gdSjlx"-->
                                <!--placeholder="请选择">-->
                                <!--<el-option-->
                                <!--v-for="item in selectDataObj.cdg_wgsjlx"-->
                                <!--:key="item.value"-->
                                <!--:label="item.label"-->
                                <!--:value="item.value"-->
                                <!--/>-->
                                <!--</el-select>-->
                            </el-form-item>
                        </div>
                    </div>
                    <div class="handInput_from_subTitle">
                        <span class="handInput_from_verticalLine"></span>
                        <p>反映问题</p>
                    </div>
                    <div class="handInput_from_subMain">
                        <div class="handInput_from_subMain_list" style="width: 100%">
                            <!--<div class="handInput_from_subMain_label">-->
                            <!--工单标题-->
                            <!--</div>-->
                            <el-form-item label="工单标题" prop="gdBt">
                                <!--<input class="handInput_from_subMain_input" type="text"-->
                                <!--v-model="wordOrderIputForm.gdBt"-->
                                <!--maxlength="50"-->
                                <!--show-word-limit-->
                                <!--placeholder="请输入">-->
                                <el-input
                                    class="handInput_from_subMain_input inputWordLimit"
                                    v-model="wordOrderIputForm.gdBt"
                                    maxlength="50"
                                    placeholder="请输入"
                                    show-word-limit
                                    type="text"
                                />
                            </el-form-item>
                        </div>
                        <div class="handInput_from_subMain_list" style="width: 100%">
                            <el-form-item label="主要内容" prop="gdZynr">
                                <el-input
                                    v-model="wordOrderIputForm.gdZynr"
                                    class="handInput_from_subMain_textarea"
                                    maxlength="2000"
                                    show-word-limit
                                    :autosize="{ minRows: 5}"
                                    type="textarea"
                                    placeholder="请输入"
                                />
                            </el-form-item>
                        </div>

                    </div>
                </div>
                <div class="file_subTitle">
                    <div class="file_subTitle_left">
                        <span class="file_verticalLine"></span>
                        <p>工单附件</p>
                    </div>
                    <div class="file_subTitle_right">
                        <el-upload
                            class="upload-demo"
                            action="/jgfast/sys/comm/upload"
                            :show-file-list="false"
                            :headers="headerObj"
                            accept="video/*, image/*"
                            multiple
                            :on-success="handleFileSuccess"
                            :before-upload = "beforeUpload"
                        >
                            <div class="file_subTitle_btn">
                                <el-icon>
                                    <upload/>
                                </el-icon>
                                <span>添加附件</span>
                            </div>
                        </el-upload>
                    </div>
                </div>
                <div class="Jsjb_file">
                    <!--<div class="file_list">-->
                    <!--<el-table v-if="fileList.length>0" :data="fileList" style="width: 100%">-->
                    <!--&lt;!&ndash;<el-table-column type="selection" width="55"/>&ndash;&gt;-->
                    <!--<el-table-column prop="fileImg" width="35">-->
                    <!--<template #default="scope">-->
                    <!--<div style="display: flex; align-items: center">-->
                    <!--<img v-if="scope.row.fileImg=='1'" class="fileIcon"-->
                    <!--src="../../assets/images/ico_pdf.png" alt="">-->
                    <!--<img v-else-if="scope.row.fileImg=='2'" class="fileIcon"-->
                    <!--src="../../assets/images/ico_word.png" alt="">-->
                    <!--<img v-else-if="scope.row.fileImg=='3'" class="fileIcon"-->
                    <!--src="../../assets/images/ico_excel.png" alt="">-->
                    <!--<img v-else-if="scope.row.fileImg=='4'" class="fileIcon"-->
                    <!--src="../../assets/images/ico_tp.png" alt="">-->
                    <!--<img v-else-if="scope.row.fileImg=='5'" class="fileIcon"-->
                    <!--src="../../assets/images/ico_yp.png" alt="">-->
                    <!--<img v-else-if="scope.row.fileImg=='6'" class="fileIcon"-->
                    <!--src="../../assets/images/ico_other.png" alt="">-->
                    <!--<img v-else class="fileIcon" src="../../assets/images/ico_other.png" alt="">-->
                    <!--</div>-->
                    <!--</template>-->
                    <!--</el-table-column>-->
                    <!--<el-table-column prop="fileName" width="300"/>-->
                    <!--<el-table-column prop="fileSizeShow"/>-->
                    <!--&lt;!&ndash;<el-table-column prop="address" min-width="25%"/>&ndash;&gt;-->
                    <!--<el-table-column align="right">-->
                    <!--<template #default="scope">-->
                    <!--<div style="display: flex; align-items: center;justify-content: right">-->
                    <!--<i class="icon-success-outline"></i>-->
                    <!--<i class="icon-eye_line" @click="handleFilePreview(scope.row)"></i>-->
                    <!--<i class="icon-download_2_line" @click="handleFileDownload(scope.row)"></i>-->
                    <!--<el-icon class="icon-remove" @click="handleFileRemove(scope.row)">-->
                    <!--<delete/>-->
                    <!--</el-icon>-->
                    <!--</div>-->
                    <!--</template>-->
                    <!--</el-table-column>-->
                    <!--</el-table>-->
                    <!--</div>-->
                    <div class="file_list">
                        <div class="file_list_img">
                            <div class="file_list_img_item" v-for="(item,index) in imgFileList">
                                <img :src="item.src" alt="">
                                <div class="file_list_img_modal">
                                    <i class="icon-eye_line" @click="handleImgPreview(imgFileList,item,index)"></i>
                                    <i class="icon-download_2_line" @click="handleFileDownload(item)"></i>
                                    <el-icon class="icon-remove" @click="handleFileRemove(item,'img',index)">
                                        <delete/>
                                    </el-icon>
                                </div>
                            </div>
                        </div>
                        <div class="file_list_img">
                            <div class="file_list_img_item" v-for="(item,index) in radioFileList">
                                <img src="../../assets/images/radioImg.png" alt="">
                                <div class="file_list_img_modal">
                                    <i class="icon-eye_line" @click="handleFilePreview(item)"></i>
                                    <i class="icon-download_2_line" @click="handleFileDownload(item)"></i>
                                    <el-icon class="icon-remove" @click="handleFileRemove(item,'radio',index)">
                                        <delete/>
                                    </el-icon>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="handInput_left_btn">
                    <el-form-item>
                        <div class="handInput_left_btn_cancle">
                            取消
                        </div>
                        <div class="handInput_left_btn_hold" @click="submitForm(ruleFormRef)">
                            保存
                        </div>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="handInput_right">
            <div class="handInput_noContent">
                <img src="../../assets/images/Frame369.png" alt="">
            </div>
        </div>
        <Map ref="sonRef"></Map>
    </div>
    <ImgCarousel ref="imgCarouselChild" :imgList="imgFileList" :imgListIndex="imgListIndex"></ImgCarousel>
</template>

<script>
    import {reactive, onMounted,onBeforeUnmount, ref, getCurrentInstance, watch, computed} from 'vue';
    import {dateFormat, filePreview, fileDownload} from '../../assets/js/base.js';
    import {ElMessageBox,ElMessage, ElLoading} from 'element-plus'
    import {useStore} from 'vuex';
    import File from '@/components/EventManage/Jsjb/File.vue'
    import Map from '@/components/map/Map';
    import ImgCarousel from '@/components/ImgCarousel/ImgCarousel.vue';//重新分派

    export default {
        name: "Jsjb_handInput",
        components: {File, Map, ImgCarousel},
        props: ["parentToChild"],
        setup(props, context) {
            const {proxy} = getCurrentInstance();
            const store = useStore();
            const ruleFormRef = ref();
            //上传请求头部
            const headerObj = ref({
                "device": "H5",
                "token": localStorage.getItem('user_token')
            })
            let wordOrderIputForm = reactive({
                gdGdlx: "",//工单类型
                gdSbrmc: "",
                gdSbsj: "",
                gdBt: "",
                gdFsdz: "",
                gdZynr: "",
                gdSjlx: "",
                gdFsdzJd: "",
                gdFsdzWd: "",
                gdAfcs:"",
                gdAfpq:"",
                fileIds: [],
                gdId:"",
                gdSzwg:''
            });
            const rules = reactive({
                gdSzwg:[
                    {required: true, message: "请选择所在网格", trigger: 'blur'},
                ],
                gdAfcs:[
                    {required: true, message: "请选择案发村社", trigger: 'blur'},
                ],
                gdSjlx: [
                    {required: true, message: "请选择事件类型", trigger: 'blur'},
                ],
            });
            //地址选取
            watch(() => store.state.addressName, (newVal) => {
                wordOrderIputForm.gdFsdz = newVal;
            })
            wordOrderIputForm.gdFsdzJd = computed(() => {
                return store.state.lnglat[0]
            })
            wordOrderIputForm.gdFsdzWd = computed(() => {
                return store.state.lnglat[1]
            })

            watch(() => store.state.afcsMapVal, (newVal) => {
                wordOrderIputForm.gdSzwg = newVal.substring(0, 2);
                afcsSelectArr.value = afcsSelectObj.value[wordOrderIputForm.gdSzwg];
                setTimeout(function () {
                    wordOrderIputForm.gdAfcs = newVal;
                },300)
            })

            watch(() => store.state.afpqMapVal, (newVal) => {
                wordOrderIputForm.gdAfpq = newVal;
            })

            // 获取代码表
            let selectDataObj = ref({});
            let sjlxLaqk = ref("")
            let sjlxLaqkObj = ref({})
            //案发村社select选项
            let afcsSelectObj=ref({})
            let afcsSelectArr=ref([])
            const selectData = () => {
                proxy.$axios.get("/jgfast/wgsj/selSjlxDzxx").then((res) => {
                    sjlxLaqkObj.value = res.data;
                });
                proxy.$axios.post("/jgfast/wgsj/getCodeTable", {
                    "codeTable": "cdg_wgsjlx,cdg_wgsj_gdlx,cdg_wgsj_afcs"
                }).then((res) => {
                    if(store.state.gdlxSelectedGeneralEvents){
                        res.data.cdg_wgsj_gdlx.map(item =>{
                            if(item.value =="wwg"){
                                item.disabled=true
                            }
                        })
                    }
                    selectDataObj.value = res.data;
                    res.data.cdg_wgsj_afcs.map(item=>{
                        // let obj = {
                        //     value:"",
                        //     label:""
                        // }
                        afcsSelectObj.value[item.value]=item.children
                    })
                });
            }
            watch(()=>wordOrderIputForm.gdSzwg,(newVal)=>{
                wordOrderIputForm.gdAfcs=""
                afcsSelectArr.value = afcsSelectObj.value[newVal]
            })
            //工单录入提交
            let submitFlag = true
            const submitForm = (param) => {
                // if(!store.state.isZybjIn){
                //     ElMessage({
                //         type: 'warning',
                //         showClose: false,
                //         message: '事件位置不在镇域范围内',
                //         center: true,
                //         duration: "2000"
                //     })
                //     return;
                // }


                // store.commit("headerActiveTabChange","Hotline");
                if (submitFlag) {
                    submitFlag = false
                    if (!param) {
                        submitFlag = true;
                        return
                    }
                    let loading;
                    loading = ElLoading.service({
                        lock: true,
                        text: 'Loading',
                        background: 'rgba(0, 0, 0, 0.7)',
                    })
                    param.validate((valid, fields) => {
                        if (valid) {
                            if (!props.parentToChild?.editBealon) {
                                proxy.$axios.post("/jgfast/wgsj/insGdxx", wordOrderIputForm).then((res) => {
                                    submitFlag = true;
                                    loading.close();
                                    store.state.addNewWorkorderSuccess = true;
                                    // store.commit('addLeftTreeToHeaderTab', {
                                    //     name: "Hotline",
                                    //     label: wordOrderIputForm.gdId,
                                    //     // label: wordOrderIputForm.gdGdbh,
                                    //     linkTo: "/Hotline",
                                    //     query: {
                                    //         gdId: res.data
                                    //     },
                                    // });
                                    store.commit('deletLeftTreeToHeaderTab', "手动录入");
                                    store.commit('headerActiveTabChange',  store.state.leftTreeToHeaderTab[ store.state.leftTreeToHeaderTab.length-1].label);

                                }).catch(() => {
                                    submitFlag = true;
                                    loading.close();
                                });
                            } else {
                                wordOrderIputForm.czCzlx ="GDXG"
                                proxy.$axios.post("/jgfast/wgsj/gdcz", wordOrderIputForm).then((res) => {
                                    submitFlag = true;
                                    loading.close();
                                    store.state.addNewWorkorderSuccess = true;
                                    store.state.gdxgRefreshData = true;
                                    // store.commit('deletLeftTreeToHeaderTab', wordOrderIputForm.gdGdbh);
                                    // store.commit('deletLeftTreeToHeaderTab', wordOrderIputForm.gdId)
                                    // setTimeout(() => {
                                    //     store.commit('addLeftTreeToHeaderTab', {
                                    //         name: "Hotline",
                                    //         label: wordOrderIputForm.gdId,
                                    //         // label: wordOrderIputForm.gdGdbh,
                                    //         linkTo: "/Hotline",
                                    //         query: {
                                    //             gdId: wordOrderIputForm.gdId
                                    //         },
                                    //     });
                                    // })

                                    store.commit('deletLeftTreeToHeaderTab', "编辑-" + wordOrderIputForm.gdId);
                                    // store.commit('deletLeftTreeToHeaderTab', "手动录入");
                                    store.commit('headerActiveTabChange',  store.state.leftTreeToHeaderTab[ store.state.leftTreeToHeaderTab.length-1].label);
                                }).catch(() => {
                                    submitFlag = true;
                                    loading.close();
                                });
                            }
                        } else {
                            submitFlag = true
                            loading.close();
                        }
                    })
                }
            }
            watch(() => wordOrderIputForm.gdPdsj, (newVal) => {
                if (newVal) {
                    clsxHourDisable.value = false;
                    clsxDayDisable.value = false;
                    if (wordOrderIputForm.gdClsxxs) {
                        clsxDayDisable.value = true;
                        clsxHourDisable.value = false;
                        var nowDate = new Date(wordOrderIputForm.gdPdsj);
                        nowDate.setHours(nowDate.getHours() + Number(wordOrderIputForm.gdClsxxs))
                        wordOrderIputForm.gdJzsj = dateFormat(nowDate)
                    }
                    if (wordOrderIputForm.gdClsxzrr) {
                        clsxHourDisable.value = true;
                        clsxDayDisable.value = false;
                        var nowDate = new Date(wordOrderIputForm.gdPdsj);
                        nowDate.setDate(nowDate.getDate() + Number(wordOrderIputForm.gdClsxzrr));
                        wordOrderIputForm.gdJzsj = dateFormat(nowDate);
                    }
                } else {
                    clsxHourDisable.value = true;
                    clsxDayDisable.value = true;
                }
            })
            let clsxHourDisable = ref(true);//处理时限小时
            let clsxDayDisable = ref(true);//处理时限自然日
            const clsxHourInput = (param) => {
                if (param) {
                    wordOrderIputForm.gdClsxxs = +param;
                    clsxDayDisable.value = true;
                    clsxHourDisable.value = false;
                    var nowDate = new Date(wordOrderIputForm.gdPdsj);
                    nowDate.setHours(nowDate.getHours() + Number(param))
                    wordOrderIputForm.gdJzsj = dateFormat(nowDate)
                } else {
                    wordOrderIputForm.gdClsxxs = "";
                    wordOrderIputForm.gdJzsj = "";
                    clsxHourDisable.value = false;
                    clsxDayDisable.value = false;
                }
            };
            const clsxDayInput = (param) => {
                if (param) {
                    clsxHourDisable.value = true;
                    wordOrderIputForm.gdClsxzrr = +param;
                    clsxDayDisable.value = false;
                    var nowDate = new Date(wordOrderIputForm.gdPdsj);
                    nowDate.setDate(nowDate.getDate() + Number(param));
                    wordOrderIputForm.gdJzsj = dateFormat(nowDate);
                } else {
                    wordOrderIputForm.gdClsxzrr = "";
                    clsxHourDisable.value = false;
                    wordOrderIputForm.gdJzsj = "";
                    clsxDayDisable.value = false;
                }
            }
            //文件上传
            const fileList = ref([]);
            //文件上传成功
            let imgFileList = ref([])
            let radioFileList = ref([])
            const handleFileSuccess = (param) => {
                param.fileId = param.id;
                fileList.value.push(param);
                param.src = "/jgfast/sys/comm/fileUploadView?fileId=" + param.fileId
                wordOrderIputForm.fileIds.push(param.id)
                if (param.fileImg == 4) {
                    imgFileList.value.push(param)
                } else {
                    radioFileList.value.push(param)
                }
            }
            //文件查看
            const handleFilePreview = (param) => {
                filePreview(param.fileName, param.fileId)
            }
            //文件下载
            const handleFileDownload = (param) => {
                fileDownload(param.fileId)
            }
            //文件删除
            const handleFileRemove = (param, type, indexFile) => {
                var index = wordOrderIputForm.fileIds.indexOf(param.fileId);
                fileList.value.splice(index, 1);
                wordOrderIputForm.fileIds.splice(index, 1);
                if (type == "img") {
                    imgFileList.value.splice(indexFile, 1);
                } else {
                    radioFileList.value.splice(indexFile, 1);
                }
            }
            //图片查看
            //触发子组件事件
            const imgCarouselChild = ref()
            let imgListIndex = ref()
            const imgsrc = (param) => {
                return "/jgfast/sys/comm/fileUploadView?fileId=" + param
            }
            const handleImgPreview = (imgFileList, item, index) => {
                imgListIndex.value = index;
                imgCarouselChild.value.showImgCarousel()
            }
            //打开地图
            const sonRef = ref();
            const openMapModal = () => {
                sonRef.value.closeOpenModal('block')
            }
            //回显编辑
            const echoEdit = () => {
                proxy.$axios.post("/jgfast/wgsj/selGdxxxq", {
                    "gdId": props.parentToChild?.gdId
                }).then((res) => {
                    wordOrderIputForm.gdGdlx = res.data.gdGdlx;
                    wordOrderIputForm.gdSbrmc = res.data.gdSbrmc;
                    wordOrderIputForm.gdSbsj = res.data.gdSbsj;
                    wordOrderIputForm.gdBt = res.data.gdBt;
                    wordOrderIputForm.gdFsdz = res.data.gdFsdz;
                    wordOrderIputForm.gdZynr = res.data.gdZynr;
                    wordOrderIputForm.gdSjlx = res.data.gdSjlx;
                    wordOrderIputForm.gdAfcs= res.data.gdAfcs;
                    store.state.lnglat = [res.data.gdFsdzJd, res.data.gdFsdzWd]
                    fileList.value = res.data.files;
                    res.data.files.map(item => {
                        wordOrderIputForm.fileIds.push(item.fileId)
                        if (item.fileImg == 4) {
                            item.src = "/jgfast/sys/comm/fileUploadView?fileId=" + item.fileId
                            imgFileList.value.push(item)
                        } else if (item.fileImg == 6) {
                            radioFileList.value.push(item)
                        }
                    })
                    wordOrderIputForm.gdId = res.data.gdId;
                });
            }
            let sbPerson = ref("")
            const beforeUpload =(file)=>{
                // console.log(file.type.indexOf("image")>-1   )
                // // video/*, image
                if(!(file.type.indexOf("image")>-1) && !(file.type.indexOf("video")>-1) ){
                    return false
                }

            }
            let selectReadonly = ref(false)//工单类型只读
            //事件类型
            const sjlxhandleChange = (val)=>{
                sjlxLaqk.value = sjlxLaqkObj.value[val].laqk;
                if(!wordOrderIputForm.gdBt){
                    wordOrderIputForm.gdBt = sjlxLaqkObj.value[val].sjlxmc1;
                }
            }
            onMounted(() => {
                selectData();
                //请求工单编号和上报人
                // proxy.$axios.post("/jgfast/wgsj/insGdxxInit").then((res) => {
                //     wordOrderIputForm.gdSbrmc = res.data.userName;
                //     wordOrderIputForm.gdGdbh = res.data.gdbh;
                // });
                //上报人
                proxy.$axios.post("/jgfast/sys/user/userInfo").then((res) => {
                    sbPerson.value = res.user.name
                });
                //当前时间
                wordOrderIputForm.gdSbsj = String(new Date().getFullYear()) + '-' + String((new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1)) + '-' + String(new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate()) + ' ' + String(new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours()) + ":" + String(new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()) + ":" + String(new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds())
                if (props.parentToChild?.editBealon) {
                    echoEdit()
                    selectReadonly.value = true
                }
            })

            onBeforeUnmount(() => {
                console.log("销毁组件123")
            })
            return {
                wordOrderIputForm,
                submitForm,
                rules,
                ruleFormRef,
                selectDataObj,
                clsxDayDisable,
                clsxHourDisable,
                clsxDayInput,
                clsxHourInput,
                fileList,
                handleFileSuccess,
                handleFilePreview,
                handleFileRemove,
                handleFileDownload,
                headerObj,
                openMapModal,
                sonRef,
                imgFileList,
                radioFileList,
                handleImgPreview,
                imgListIndex,
                imgCarouselChild,
                sbPerson,
                beforeUpload,
                selectReadonly,
                sjlxhandleChange,
                sjlxLaqk,
                afcsSelectArr
            }
        }
    }
</script>

<style scoped>

</style>
